export const PLACEHOLDER_IMAGE =
  'https://placehold.co/640x640?text=NO IMAGE' as const;
export const LOADING_IMAGE =
  'https://placehold.co/640x640?text=LOADING' as const;
export const BLACK_TEXTURE =
  'https://res.cloudinary.com/dbzzletpw/image/upload/v1756974954/black-texture_vlvuxl.jpeg' as const;

export const SKELETON_PROFILE = {
  imgUrl: LOADING_IMAGE,
  id: `skeleton-profile`,
};
